


import { EAuditStatus } from '../interfaces/IAudit';
import { JSONSchema } from "../../sg-schema/RJSF";


export interface ISchemaContext {
    roles: string[];
    mode: "display" | "form",
    status: EAuditStatus,
}

export const contextSchema: JSONSchema = {
    "type": "object",
    "properties": {
        "roles": {
            "type": "array",
            "items": {
                "type": "string"
            }
        },
        "mode": {
            "type": "string",
            "enum": ["display", "form"]
        },
        "status": {
            "type": "string",
            "enum": [EAuditStatus.Draft, EAuditStatus.Finished]
        },

        "canViewNames": {
            "type": "boolean"
        },
    }
}
